module.exports = __webpack_public_path__ + "img/front_18.065e1595.svg";